import { MdInfoOutline, MdRequestPage } from "react-icons/md"
import { Container, FirstGrid, Header, BillingSelect, CloseInvoiceBtn, HeaderSeparation } from "./styles"
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BillingCard } from "../../components/billing-card";
import { BillingTable } from "../../components/billing-table";
import { useHistory } from "react-router-dom";
import { overview } from "../../../../services/billing-partner-overview.service";
import { Calendar } from "primereact/calendar";



export const Billing = (): JSX.Element => {
    const d = new Date()
    const { t: translation } = useTranslation()
    const history = useHistory()
    const [formattedDate, setFormattedDate] = useState<string>('06-22')
    const [month, setMonth] = useState(d.getMonth() + 1)
    const [currentMonth] = useState(d.getMonth() + 1)
    const [date, setDate] = useState<any>(d);
    const [isLoading, setIsLoading] = useState(false)
    const [closedInvoiceDate, setClosedInvoiceDate] = useState<string>()
    const [profitEstimate, setProfitEstimate] = useState(23346.27)
    const [totalRequests, setTotalRequests] = useState<number>(0)
    const [aggregate, setAggregate] = useState<number>(0)
    const [currentBalance, setCurrentBalance] = useState<number>(0)
    const [isInvoiceClosed, setIsInvoiceClosed] = useState(false)
    const [materials, setMaterials] = useState<any[]>([])

    useEffect(() => { 
        if(date) {  
            let j = date as Date
            setMonth(j.getMonth() + 1)
            setFormattedDate(`${j.getMonth() + 1}-${j.getFullYear().toString().substr(2)}`)
        }
        
    }, [date])

    useEffect(() => {
        setIsLoading(true)
        overview(formattedDate).then((res) => {
            setAggregate(res.accumulated || 0)
            setProfitEstimate(res.transfer_estimate || 0)
            setCurrentBalance(res.total_money || 0)
            setTotalRequests(res.requests || 0)
            setIsLoading(false)
            setMaterials(res.materials || [])
            setIsInvoiceClosed(() => { 
                if(res.closed_at) { 
                    return true
                }
                return false
            })
            setClosedInvoiceDate(() => new Date(res.closed_at).toLocaleDateString('pt-BR'))
        }).catch(() => {})
    }, [formattedDate])

    const requestTransfer = () => {
        history.push('/manager/partner/new-withdrawal')
    }

    const tableColumns = [
        {field:"discipline", header:translation('contactForm.labelName'), sortable: true},

        {field:"material_used", headerStyle:{ justifyContent: 'center' }, bodyStyle:{ justifyContent: 'center', fontWeight: 400 }, 
        header:translation('manager.billing.use'), sortable:true},

        {field:"external_access", headerStyle:{ justifyContent: 'center' }, bodyStyle:{ justifyContent: 'center', fontWeight: 400 },
         header:translation('manager.dashboard.secondChart.firstLabel'), sortable:true},

        {field:"material_value" , headerStyle:{ justifyContent: 'center' }, bodyStyle:{ justifyContent: 'center', fontWeight: 700 },
         header:translation('manager.billing.gainEstimate'), sortable:true, isMoney:true}
    ]


    return (
        <Container>
            <Header>
                <HeaderSeparation style={{ alignItems: 'flex-end' }}>
                    <h1>{translation('manager.billing.title')}</h1>
                    <span><span id="periodDesc"> {translation('manager.billing.reference')}: </span>01/{month < 10 ? `0${month}` : month}/{d.getFullYear()} - {month === 2 ? '28' : month % 2 ? '31' : '30'}/{month < 10 ? `0${month}` : month}/{d.getFullYear()}</span>
                </HeaderSeparation>
                <HeaderSeparation style={{ alignItems: 'center' }}>
                    <div>

                    <BillingSelect>
                            <span>{translation('manager.billing.selectEpoch')}</span>
                            <Calendar inputStyle={{  height: 35  }} id="monthpicker" value={date} onChange={(e: any) => setDate(e.value)} view="month" dateFormat="mm/yy" />
                        </BillingSelect>
                    </div>
                    {(currentMonth !== month || isInvoiceClosed) && (
                        <span style={{ marginLeft: 10 }}> {translation('manager.billing.currentBalance')}: <span style={{ fontWeight: 700, color: '#37C896' }}> R$ 13.343,09 </span> </span>
                    )}
                    {currentMonth === month && !isInvoiceClosed && (<CloseInvoiceBtn type="button" data-testid="withdrawal" isDisabled={false} onClick={requestTransfer}> {translation('manager.billing.requestWithdrawal')} </CloseInvoiceBtn>)}

                </HeaderSeparation>
            </Header>
            <FirstGrid>
                <BillingCard
                    isLoading={isLoading}
                    label={currentMonth === month || isInvoiceClosed ? translation('manager.billing.currentBalance') : translation('manager.billing.balance')}
                    value={currentBalance}
                    color={isInvoiceClosed || currentMonth < month || currentBalance === 0  ? "#CCCCCC" : "#37C896"}
                    hasVisibleToggle
                    isMoney
                />
                <BillingCard
                    isLoading={isLoading}
                    label={currentMonth === month && !isInvoiceClosed ? translation('manager.billing.gainEstimate') : translation('manager.billing.gain')}
                    value={profitEstimate}
                    color={isInvoiceClosed || currentMonth < month || profitEstimate === 0 ? "#CCCCCC" : currentMonth === month ? "#FFB70D" : '#6473FF'}
                    hasVisibleToggle
                    isMoney
                />
                <BillingCard
                    isLoading={isLoading}
                    label={translation('manager.billing.requests')}
                    value={totalRequests}
                    color={isInvoiceClosed || currentMonth < month  || totalRequests === 0 ? "#CCCCCC" : '#F39035'}
                    icon={<MdRequestPage size={38} />}
                />
                <BillingCard
                    isLoading={isLoading}
                    label={translation('manager.billing.aggregate')}
                    value={aggregate}
                    color={"#CCCCCC"}
                    isMoney
                    hasVisibleToggle
                />

            </FirstGrid>
            {isLoading ? (
                <div className="loading-container mt-5">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : (
                <main>
                    <BillingTable  itens={materials} columns={tableColumns} emptyMessage="Você não possui nenhum material publicado" priceColumn="material_value"/>
                    {isInvoiceClosed && closedInvoiceDate && (
                        <div style={{ textAlign: 'end', marginTop: 20, marginBottom: 20 }}>
                            {/* <span >{translation('manager.billing.closedInvoice')}: {`${closedInvoiceDate.getDate()}/${closedInvoiceDate.getMonth() + 1 < 10 ? `0${closedInvoiceDate.getMonth() + 1}` : closedInvoiceDate.getMonth() + 1}/${closedInvoiceDate.getFullYear()}`}</span> */}
                            <span >{translation('manager.billing.closedInvoice')}: {closedInvoiceDate}</span>

                        </div>
                    )}
                    {!isInvoiceClosed && currentMonth > month && (
                        <div style={{ textAlign: 'end', marginTop: 20, marginBottom: 20 }}>
                            <span style={{ marginLeft: 10, }}> <MdInfoOutline style={{ marginRight: 10 }} /> {translation('manager.billing.invoiceWarning1')}<b>{translation(`manager.dashboard.filterChart.months.${month}`)}</b> {translation('manager.billing.invoiceWarning2')}</span>
                        </div>
                    )}
                </main>
            )}



        </Container>
    )
}